import { IFilterFactory } from '../../../../interfaces/filter-factory.interface';
import { BaseFilterProps } from '_types';
import OptionsRangeFilter from './filter';

class OptionsRangeFilterFactory implements IFilterFactory {
  get type() {
    return 'OptionsRange';
  }

  create({ field, item, searchState, dispatcher }: BaseFilterProps) {
    const key = [field, JSON.stringify(searchState.filters || {})].join('-');
    return (
      <OptionsRangeFilter
        key={key}
        field={field}
        item={item}
        searchState={searchState}
        dispatcher={dispatcher}
      />
    );
  }
}

export default OptionsRangeFilterFactory;
